import React from 'react';
import * as styles from './badges.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Badge = _ref => {
  var label = _ref.label,
    colour = _ref.colour,
    textColour = _ref.textColour,
    className = _ref.className;
  return ___EmotionJSX("span", {
    css: styles.badge(colour, textColour),
    className: className
  }, label);
};
var BadgesWrapper = props => ___EmotionJSX("div", {
  css: styles.wrapper
}, props.children);
export { Badge, BadgesWrapper };